import { h } from "preact";
import { Transition } from 'preact-transitioning';
import { useEffect, useState } from "preact/hooks";
import { DustEffect } from '../libs/dust-effect/src/DustEffect';

function SlideImage ({ image, isActive }: any) {
  const [show, setShow] = useState(true);
  const [opacity, setOpacity] = useState(0);

  const timings = {
    enter: 1000,
    exit: 500,
  }
  const [duration, setDuration] = useState(timings.exit);

  const directions = {
    enter: {
      translateX: -150,
      translateY: -120,
    }, 
    exit: {
      translateX: 150,
      translateY: -120,
    }, 
  }
  const [direction, setDirection] = useState(directions.exit); 
  const canvasNum = (document.body.clientWidth > 991) ? 5 : 0;
  
  useEffect(() => {
    // disintegrate image after render if not current
    if (!isActive){
      setShow(false);
    }
  }, [isActive])
  return (
          <div className="index__wrapper-slider-slide-block">
              <picture>
                <source type="image/webp" srcSet={`${image}`} />
                  <Transition
                    in={isActive}
                    appear={true}
                    alwaysMounted={true}
                    duration={duration}
                    onEnter={() => {
                      setDirection(directions.enter)
                      setDuration(timings.enter)
                    }}
                    onEntering={() => {
                      setOpacity(1);
                      setShow(true) 
                    }}
                    onExit={() => {
                        setDirection(directions.exit)
                        setDuration(timings.exit)
                        setShow(false);
                    }}
                    onExited={() => setOpacity(0)}
                  >
                    {
                      () => (
                        <DustEffect
                          src={`${image}`}
                          style={{
                            opacity,
                            transition: `opacity ${duration * 0.8}ms ease-in-out`
                          }}
                          show={show}
                          option={{
                            canvasNum: canvasNum,
                            translateX: direction.translateX,
                            translateY: direction.translateY,
                            baseDuration: 200,
                            rotateMax: 18,
                            blur: 0.6,
                            outerTimeoutDelay: 40,
                            innerTimeoutDelay: 75,
                          }}
                        />
                      )
                    }
                </Transition>
              </picture>
          </div>
  )
}
export { SlideImage };
